import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'check', 'Check', [["path",{"d":"M5 12l5 5l10 -10"}]]);